import { NgModule } from '@angular/core';
import { PhoneCallSenderComponent } from './phone-call-sender.component';
import { DatepickerModule } from '../../../shared/datepicker/datepicker.module';
import { SharedModule } from '../../../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FeedbackDetailCoreModule } from '../../shared/feedback-detail/feedback-detail.core.module';
import { CommunicationService } from '../../../../services/communication/communication.service';

@NgModule({
    imports: [
        SharedModule,
        DatepickerModule,
        FeedbackDetailCoreModule,
        NgbModule,
    ],
    declarations: [PhoneCallSenderComponent],
    exports: [PhoneCallSenderComponent],
    providers: [
        CommunicationService,
    ],
})
export class PhoneCallSenderModule
{
}
